import { render, staticRenderFns } from "./create.vue?vue&type=template&id=40ff9760&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=40ff9760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff9760",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40ff9760')) {
      api.createRecord('40ff9760', component.options)
    } else {
      api.reload('40ff9760', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=40ff9760&scoped=true&", function () {
      api.rerender('40ff9760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/start/login/create.vue"
export default component.exports